/**
 * Deal stage constants and configurations
 */

import type { DealStage } from '../types';

export const DEAL_STAGES: Record<DealStage, { label: string; color: string; order: number }> = {
  pitching: {
    label: 'Pitching',
    color: '#60a5fa', // blue-400
    order: 1,
  },
  negotiating: {
    label: 'Negotiating',
    color: '#fbbf24', // amber-400
    order: 2,
  },
  contract_signed: {
    label: 'Contract Signed',
    color: '#a78bfa', // violet-400
    order: 3,
  },
  content_in_progress: {
    label: 'Content in Progress',
    color: '#fb923c', // orange-400
    order: 4,
  },
  awaiting_payment: {
    label: 'Awaiting Payment',
    color: '#14b8a6', // teal-500
    order: 5,
  },
  completed: {
    label: 'Completed',
    color: '#22c55e', // green-500
    order: 6,
  },
};

export const DEAL_STAGE_ORDER: DealStage[] = [
  'pitching',
  'negotiating',
  'contract_signed',
  'content_in_progress',
  'awaiting_payment',
  'completed',
];

export const ACTIVE_DEAL_STAGES: DealStage[] = [
  'pitching',
  'negotiating',
  'contract_signed',
  'content_in_progress',
  'awaiting_payment',
];

export const CLOSED_DEAL_STAGES: DealStage[] = ['completed'];
